import CmsBlocks from 'libs/wordpress/content/CmsBlocks';
import ColumnsLayout from 'components/contentLayouts/ColumnsLayout';
import MaxWidthWrapper from 'components/wrappers/MaxWidthWrapper';
import PropTypes from 'prop-types';
import React from 'react';
import { mediaQueries } from 'config/theme/breakpoints';

const TwoColumnsLayout = ({ content, ...rest }) => {
    const { columns } = content;

    // Handle how the content inside each columns should be rendred
    const moduleArray = columns.map((col, i) => {
        const { layout } = col;
        return <CmsBlocks isColumn key={`${layout}-${i}`} mediaQuery={mediaQueries.twoColumn} data={col} {...rest} />;
    });

    return (
        <MaxWidthWrapper includeContentMargins as="section" mb={['48px', null, null, '64px']}>
            <ColumnsLayout blocks={moduleArray} columnSizes={[12, null, 6, 4]} />
        </MaxWidthWrapper>
    );
};

TwoColumnsLayout.propTypes = {
    content: PropTypes.object,
};

export default TwoColumnsLayout;
